import React from 'react'
import {Flex, Spinner} from '/app/src/component'
import { connect } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import TicketActivityRow from './TicketActivityRow'

import EmployeeSelector from '/app/src/model/Employee/selector'
import DateTime from '/app/src/lib/DateTime';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function TicketActivityList({latestTickets, isLoading}) {
    const classes = useStyles();
    return (
        <Flex
            borderRadius='20px'
            bg='LightGray1'
            direction='column'
            overflow='hidden'>
            <Flex
                fontSize='21px'
                fontWeight='500'
                center
                paddingTop='25px'
                paddingBottom='10px'>
                    Senast mottagna ärenden
            </Flex>
            <Flex>
                <TableContainer components={{ Container: props => <Paper {...props} elevation={0}/> }}>
                    <Table className={classes.table} aria-label="ticket activity">
                        <TableHead>
                            <TableRow>
                                <TableCell align='right'>Ärendet skapades</TableCell>
                                <TableCell align='left'>Kundnamn</TableCell>
                                <TableCell align='left'>Hanterad av</TableCell>
                                <TableCell align='left'>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { getBody(latestTickets, isLoading) }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Flex>
        </Flex>
    );
}

function getBody(latestTickets, isLoading) {
    let body = null;
    if (isLoading) {
        body = <Spinner  type='loading' />
    } else if (latestTickets.length === 0) {
        body = <Flex hAlignContent='center'>Det finns inga hanterade ärenden ännu.</Flex>
    } else {
        return latestTickets.map((row, i) => ( <TicketActivityRow row={row} key={i} /> ))
    }

    return (
        <TableRow>
            <TableCell colSpan={4}>{body}</TableCell>
        </TableRow>
    )
}

function mapStateToProps(state, ownProps) {
    const customers = ownProps.customers
    const latestTickets = ownProps.rooms.map(
        (roomId) => {
            const ticket = ownProps.latestTickets[roomId]

            const customerName = getCustomerName(customers, ticket);

            const active = ticket.is_resolved ? 'Avklarad' : 'Pågående' 
            const dateCreated = DateTime.getDetailedNiceDate(ticket.date_created) || 'Ingen tid'
            const assignedEmployee = EmployeeSelector.getById(state, ticket.assigned_employee_id)
            const assignedEmployeeName = EmployeeSelector.getEmployeeName(assignedEmployee)
            return { dateCreated, customerName, active, assignedEmployeeName }
        }
    ).sort()
    return { 
        latestTickets,
        isLoading: ownProps.isLoading }
}

function getCustomerName(customers, ticket) {
    if (!(ticket.customer_id in customers)) {
        return 'Okänt'
    }
    return customers[ticket.customer_id].name || '#' + customers[ticket.customer_id].company_customer_id
}

export default connect(mapStateToProps)(TicketActivityList)



// WEBPACK FOOTER //
// ./src/component/TicketActivity/TicketActivityList.js